import { useContext, useEffect } from "react";
import { FaBan } from "react-icons/fa";
import { StyledTableItem } from "./style";
import { schedulesApi } from "../../../../../services/api";
import { SupervisorContext } from "../../../../../contexts/admin/Supervisor.context";
import { toast } from "react-toastify";
import { ScheduledAttendanceDetails } from "../../../../../interfaces/Attendances.interfaces";
import { formatNumber } from "../../../../../Hooks/FormatNumber.hook";

interface iTableProps {
    schedule: ScheduledAttendanceDetails;
    update: () => void;
}

export const TableItem = ({ schedule, update }: iTableProps) => {
    const { modalState } = useContext(SupervisorContext);

    useEffect(() => {
        update();
    }, [modalState.value]);

    function cancelSchedule() {
        schedulesApi.delete(`${schedule.id}`)
            .then(res => {
                toast.success(res.data.message);
                update();
            })
            .catch(res => {
                toast.error(res.data.message);
            });
    };

    return (
        <StyledTableItem className={schedule.contactName ? "deleted_contact" : ""}>
            <div className="actions">
                {/* <FaExchangeAlt title="Abrir transferencia de agente" onClick={() => modalState.set(<UpdateOperatorDialog CODIGO_ATENDIMENTO={schedule.id} modalState={modalState} />)} /> */}
                {/* <FaCalendarAlt title="Abrir agenda de retorno" onClick={() => modalState.set(<ScheduleDialog CODIGO_ATENDIMENTO={schedule.id} modalState={modalState} />)} /> */}
                <FaBan title="Cancelar agendamento" color="red" onClick={cancelSchedule} />
            </div>
            <div className="id">
                <p>{schedule.id}</p>
            </div>
            <div className="contact">
                <p>{schedule.contactName || "n/d"}</p>
            </div>
            <div className="phone">
                <p>{schedule.contactNumber ? formatNumber(schedule.contactNumber) : "N/D"}</p>
            </div>
            <div className="customer">
                <p>{schedule.customerName || "n/d"}</p>
            </div>
            <div className="by_user">
                <p>{schedule.byUserName}</p>
            </div>
            <div className="to_user">
                <p>{schedule.toUserName}</p>
            </div>
            <div className="s_date">
                <p>{new Date(schedule.scheduleDate).toLocaleString()}</p>
            </div>

        </StyledTableItem>
    );
};